// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"6cff2cd5","283":"f34bf87f","477":"e6527ebc","488":"592f3d6f","549":"0d71fd46","620":"47614576","698":"fd34bacb"}[chunkId] + ".chunk.js";
};